// removed by extract-text-webpack-plugin
module.exports = {"header":"_3PhgC","nyh_share--article":"TsE1M","nyh_share--story":"_3BdDD"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Sharebuttons/ShareButtons.scss
 ** module id = 105
 ** module chunks = 0
 **/